<div class="footer-container">
  <img src="./../../../assets/LogoSimSave.svg" alt="Sim Save Logo" class="footer-logo-img">

  <div class="network-container">
    <div class="icon-container">
      <fa-icon [icon]="faTwitter" class="icon"></fa-icon>
    </div>
    <div class="icon-container">
      <fa-icon [icon]="faFacebook" class="icon"></fa-icon>
    </div>
    <div class="icon-container">
      <fa-icon [icon]="faInstagram" class="icon"></fa-icon>
    </div>
    <div class="icon-container">
      <fa-icon [icon]="faYoutube" class="icon"></fa-icon>
    </div>
    <div class="icon-container">
      <fa-icon [icon]="faLinkedin" class="icon"></fa-icon>
    </div>
  </div>

  <div class="contact-container">
    <div class="contact-title-container">
      <div class="icon-container">
        <fa-icon [icon]="faEnvelope" class="icon"></fa-icon>
      </div>
      <h3 class="contact-title">Fale Conosco</h3>
    </div>

    <p class="contact-content">Dúvida, crítica sugestão ou elogio? Envie um e-mail para suporte@simsave.com.br</p>
  </div>
</div>
